import { render, staticRenderFns } from "./MarketExchangePrizesModal.vue?vue&type=template&id=13e292d2&"
import script from "./MarketExchangePrizesModal.vue?vue&type=script&lang=js&"
export * from "./MarketExchangePrizesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports